module.exports = __webpack_public_path__ + "img/Number=29.15e2a0ca.png";